headerHeight = document.getElementById('header').clientHeight;
var windowHeight = window.innerHeight;
var bildHoehe = windowHeight - headerHeight;

var duoContainer = document.querySelector('.duo__container');

function setScrolltrigger() {
    scrolltrigger = ScrollTrigger.create({
        // markers: {
        //     startColor: "green",
        //     endColor: "red",
        //     fontSize: "12px"
        // },
        trigger: duoContainer,
        pin: duoContainer,
        start: () => 'top ' + ((duoContainer.getBoundingClientRect().top + document.documentElement.scrollTop) / window.innerHeight * 100) + '%',
        end: () => 'top ' + ((duoContainer.getBoundingClientRect().top + document.documentElement.scrollTop) / window.innerHeight * 100 - (98 + (70 * 3) - 17) / 1920 * window.innerWidth / window.innerHeight * 100) + '%',
        invalidateOnRefresh: true
    });
}

if (layoutAktuell == 'desktop') {
    setScrolltrigger();
}

document.addEventListener('eventLayoutaenderung', function(event) {
    if (layoutAktuell == 'desktop') {
        console.log('desktop');
        if (typeof scrolltrigger == 'undefined') {
            setScrolltrigger();
        } else {
            ScrollTrigger.enable()
        }
    } else {
        console.log('smartphone');
        ScrollTrigger.disable();
    }
})


